import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AdminNotificationsContext = createContext({ pending: { orders: 0, preorders: 0 }, refresh: () => {} });

export function AdminNotificationsProvider({ children }) {
  const { authHeader, admin } = useAuth();
  const [pending, setPending] = useState({ orders: 0, preorders: 0 });

  const refresh = useCallback(async () => {
    if (!admin) return;
    try {
      const { data } = await axios.get(`${API}/admin/stats`, authHeader());
      setPending({
        orders: data.orders_pending || 0,
        preorders: data.preorders_pending || 0,
      });
    } catch (err) {
      console.error('[AdminNotifications] Failed to fetch stats:', err);
    }
  }, [admin]);

  useEffect(() => {
    if (!admin) return;
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, [admin, refresh]);

  return (
    <AdminNotificationsContext.Provider value={{ pending, refresh }}>
      {children}
    </AdminNotificationsContext.Provider>
  );
}

export const useAdminNotifications = () => useContext(AdminNotificationsContext);
